(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[638],{

/***/ "xNax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Users", function() { return Users; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Users = function Users(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 409.7"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M146 196.4c-54.2 0-98.2-44.1-98.2-98.2S91.8 0 146 0s98.2 44.1 98.2 98.2c0 54.2-44.1 98.2-98.2 98.2zm0-169.9c-39.5 0-71.7 32.1-71.7 71.7 0 39.5 32.1 71.7 71.7 71.7s71.7-32.1 71.7-71.7c-.1-39.5-32.2-71.7-71.7-71.7zm132.8 382.8c-7.3 0-13.3-5.9-13.3-13.3 0-80.1-9-146.5-119.5-146.5S26.5 315.9 26.5 396c0 7.3-5.9 13.3-13.3 13.3S0 403.3 0 396c0-83.7 11.3-173 146-173s146 89.3 146 173c0 7.3-5.9 13.3-13.2 13.3zm207.9.4c-7.3 0-13.3-5.9-13.3-13.3 0-60.9-7.3-115.5-95.4-115.5-18 0-33.5 2.3-46.1 6.9-6.9 2.5-14.5-1-17-7.9s1-14.5 7.9-17c15.5-5.6 34-8.5 55.2-8.5 121.9 0 121.9 95.9 121.9 142 .1 7.4-5.8 13.3-13.2 13.3zM382.5 227.9c-46.4 0-84.1-37.7-84.1-84.1s37.7-84.1 84.1-84.1 84.1 37.7 84.1 84.1-37.8 84.1-84.1 84.1zm0-141.6c-31.7 0-57.5 25.8-57.5 57.5s25.8 57.5 57.5 57.5 57.5-25.8 57.5-57.5-25.8-57.5-57.5-57.5z"
  }));
};

/***/ })

}]);